import React from 'react';
import Classes from './RecordTable.module.css';
import { useNavigate } from 'react-router-dom';
import MoreDropDown from './MoreDropDown';
import DropDown from './StatusDropDown/DropDown';

function money(n, c = 'USD') {
  const v = Number(n || 0);
  try { return v.toLocaleString(undefined, { style: 'currency', currency: (c || 'USD').toUpperCase() }); }
  catch { return `$${v.toFixed(2)}`; }
}

export default function TableRow({ value, raw, onRefund }) {
  const navigateTo = useNavigate();
  const isPaid = (raw?.status || '').toLowerCase() === 'completed';
  const remaining = Math.max(0, Number(raw?.total || 0) - Number(raw?.refundedTotal || 0));
  const canRefund = isPaid && remaining > 0;

  return (
    <>
      <div className={Classes.customerRow} key={raw._id}>
        <div className={`${Classes.rowElem} ${Classes.elem1}`}><h5>{value.Number}</h5></div>
        <div className={`${Classes.rowElem} ${Classes.elem2}`}><h5>{value.Client}</h5></div>
        <div className={`${Classes.rowElem} ${Classes.elem3}`}>
          <DropDown selectedValue={value.Status} isDropDown={false} />
        </div>
        <div className={`${Classes.rowElem} ${Classes.elem4}`}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <h5>{value.Total}</h5>
            {/* {Number(value.refundedTotal) > 0 && (
              <span
                style={{
                  padding: '2px 8px',
                  borderRadius: 999,
                  background: 'rgba(99,102,241,0.12)',
                  border: '1px solid rgba(99,102,241,0.35)',
                  color: '#6366F1',
                  fontSize: 12,
                  fontWeight: 600,
                  whiteSpace: 'nowrap',
                }}
                title="Refund applied"
              >
                {`Refunded ${money(value.refundedTotal, value.currency)}`}
              </span>
            )} */}
          </div>
        </div>
        <div className={`${Classes.rowElem} ${Classes.elem5}`}><h5>{value.Created}</h5></div>
        <div className={`${Classes.rowElem} ${Classes.elem6}`}><h5>{value.Paid}</h5></div>
        <div className={`${Classes.rowElem} ${Classes.elem7}`}>
          <MoreDropDown
            invoiceId={raw._id}
            canEdit={!isPaid}
            canRefund={canRefund}
            onView={() => navigateTo(`/view-invoice/${raw._id}`)}
            onEdit={() => navigateTo(`/edit-invoice/${raw._id}`)}
            onRefund={onRefund}
          />
        </div>
      </div>

      {/* Mobile row */}
      <div className={Classes.customerRowMobile}>
        <div>
          <div className={Classes.mobElem}><h4>Number</h4><h5>{value.Number}</h5></div>
          <div className={Classes.mobElem}><h4>Client</h4><h5>{value.Client}</h5></div>
          <div className={Classes.mobElem}><h4>Status</h4><DropDown selectedValue={value.Status} isDropDown={false} /></div>
        </div>
        <div>
          <div className={Classes.mobElem}>
            <h4>Total (after refunds)</h4>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <h5>{value.Total}</h5>
              {/* {Number(value.refundedTotal) > 0 && (
                <span
                  style={{
                    padding: '2px 8px',
                    borderRadius: 999,
                    background: 'rgba(99,102,241,0.12)',
                    border: '1px solid rgba(99,102,241,0.35)',
                    color: '#6366F1',
                    fontSize: 12,
                    fontWeight: 600,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {`Refunded ${money(value.refundedTotal, value.currency)}`}
                </span>
              )} */}
            </div>
          </div>
          <div className={Classes.mobElem}><h4>Created</h4><h5>{value.Created}</h5></div>
          <div className={Classes.mobElem}><h4>Paid</h4><h5>{value.Paid}</h5></div>
        </div>
        <MoreDropDown
          invoiceId={raw._id}
          canEdit={!isPaid}
          canRefund={canRefund}
          onView={() => navigateTo(`/view-invoice/${raw._id}`)}
          onEdit={() => navigateTo(`/edit-invoice/${raw._id}`)}
          onRefund={onRefund}
        />
      </div>
    </>
  );
}
